export class FileDownloadModel {
    constructor() {
        this.fileMappedKey = "";
    }
}
export default class FileDownload extends FileDownloadModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
